import { enUS } from 'date-fns/locale'

export const defaultCopy = {
  locale: enUS,
  dropdowns: {
    monthLabel: 'Month',
    yearLabel: 'Year',
  },
  navigation: {
    previousLabel: 'Go to previous month',
    nextLabel: 'Go to next month',
  },
}

export type Copy = typeof defaultCopy
